function sessionStorageErrorHandler(fn: () => any) {
  try {
    return fn();
  } catch (e: any) {
    console.warn(
      'sessionStorage is not supported by browser settings',
      e?.message
    );

    return null;
  }
}

export function checkAvailability() {
  try {
    const x = '__storage_test__';
    sessionStorage.setItem(x, x);
    sessionStorage.removeItem(x);
  } catch {
    throw new Error('session.storage.unavailable');
  }
}

export function setItem<T>(key: string, value: T): T {
  sessionStorageErrorHandler(() =>
    sessionStorage.setItem(key, JSON.stringify(value))
  );

  return value;
}

export function getItem<T>(key: string) {
  const item = sessionStorageErrorHandler(() => sessionStorage.getItem(key));

  if (!item) {
    return null as T;
  }

  return JSON.parse(item) as T;
}

export function removeItem(key: string) {
  sessionStorageErrorHandler(() => sessionStorage.removeItem(key));
}

export function clear() {
  sessionStorageErrorHandler(() => sessionStorage.clear());
}
